/*
 * SP／タブレット帯（≤1024px）の商品ギャラリー用ドットインジケータ。
 * Dawn の SliderComponent（assets/global.js）が swipe/scroll で発火する
 * `slideChanged` イベントに追従して active ドットを更新する。
 * 矢印・「1/N」カウンターは custom.css で SP では隠し、これを beige 枠内に
 * オーバーレイ表示する（markup は snippets/product-media-gallery.liquid）。
 */
if (!customElements.get('gallery-dots')) {
  customElements.define(
    'gallery-dots',
    class GalleryDots extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = this.closest('slider-component');
        this.scrollEl = this.sliderComponent && this.sliderComponent.querySelector('[id^="Slider-"]');
        this.dots = Array.from(this.querySelectorAll('.gallery-dot'));
        if (!this.sliderComponent || !this.scrollEl || this.dots.length === 0) return;

        this.onSlideChanged = (event) => this.setActive(event.detail.currentPage - 1);
        this.sliderComponent.addEventListener('slideChanged', this.onSlideChanged);

        // ハンドラを保持し、disconnect で slideChanged と同様に解除する（登録↔解除を対称に）
        this.dotClickBindings = this.dots.map((dot, index) => {
          const handler = () => this.goTo(index);
          dot.addEventListener('click', handler);
          return { dot, handler };
        });
      }

      disconnectedCallback() {
        if (this.sliderComponent && this.onSlideChanged) {
          this.sliderComponent.removeEventListener('slideChanged', this.onSlideChanged);
        }
        this.dotClickBindings?.forEach(({ dot, handler }) => dot.removeEventListener('click', handler));
      }

      setActive(index) {
        this.dots.forEach((dot, i) => {
          const isActive = i === index;
          dot.classList.toggle('gallery-dot--active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      goTo(index) {
        const slides = this.scrollEl.querySelectorAll('.slider__slide');
        if (!slides[index]) return;
        // 前庭障害配慮（WCAG 2.3.3）＝reduced-motion 指定時は瞬間移動にする
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.scrollEl.scrollTo({
          left: slides[index].offsetLeft - slides[0].offsetLeft,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }
    }
  );
}
